(function() {
    'use strict';

    angular
        .module('atheer.system')
        .controller('SettingController', SettingController);

    /* @ngInject */
    function SettingController($scope, $state, Setting, AlertService, $mdDialog, $mdToast, $stateParams, Principal, Feature, PermissionService) {
        var vm = this;

        vm.loadingData = true;

        vm.loadAll = loadAll;
        vm.pageTitleKey = $state.$current.data.pageTitle;

        function loadAll() {
            vm.loadingData = false;
        };

        vm.loadAll();
    }
})();
